import { render, staticRenderFns } from "./CertificadoGXCV.vue?vue&type=template&id=62e41ed1&scoped=true&"
import script from "./CertificadoGXCV.vue?vue&type=script&lang=js&"
export * from "./CertificadoGXCV.vue?vue&type=script&lang=js&"
import style0 from "./CertificadoGXCV.vue?vue&type=style&index=0&id=62e41ed1&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e41ed1",
  null
  
)

export default component.exports